module.exports = __webpack_public_path__ + "img/OrderAttrCollect.68f57f2d.png";